module.exports = __webpack_public_path__ + "assets/images/04_468dad877643dee606ff2b840756d8ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/exercise-1/04.png
// module id = 228
// module chunks = 0